<div class="" id="carouselLeapmotor" data-bs-ride="carousel" data-bs-interval="7000" data-bs-pause="hover"
  class="carousel home-carousel carousel-2-cols slide">
  <div class="carousel-inner">
    <div *ngIf="!data.length" class="carousel-item active">
      <div class="carousel-inner-container">
        <div class="carousel-img-container">
        </div>
        <div class="carousel-content">
          <div class="carousel-title external-html">...</div>
        </div>
      </div>
    </div>
    <ng-container *ngFor="let item of data; let RowIndex = index">
      <div [ngClass]="{'active':RowIndex==0}" class="carousel-item">
        <div class="carousel-inner-container">
          <div class="carousel-img-container">
            <img [src]="item.ImageFile.FileUri" class="carousel-img" alt="{{item.Title}}">
          </div>
          <div class="carousel-content">
            <div [innerHTML]="item.Title" class="carousel-title external-html"></div>
            <div [innerHTML]="item.Content" class="carousel-description external-html"></div>
            <div class="carousel-cta">
              <a *ngIf="item.Url != null && item.UrlTitle != null && item.ExternalUrl == true" class="btn-black-border"
                [href]="item.Url" (click)="TrackCarrusel(item.IdElement)"
                [attr.target]="item.UrlOpenNew ? '_blank' : null" [attr.rel]="item.UrlOpenNew ? 'noopener noreferrer' : null"
                [attr.title]="item.UrlTitle">{{item.UrlTitle}}</a>
              <a *ngIf="item.Url != null && item.UrlTitle != null && item.ExternalUrl == false" class="btn-black-border"
                [attr.href]="item.Url" (click)="TrackCarrusel(item.IdElement)"
                [attr.target]="item.UrlOpenNew ? '_blank' : null" [attr.title]="item.UrlTitle">{{item.UrlTitle}}</a>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <button *ngIf="data.length>1" type="button" data-bs-target="#carouselLeapmotor" data-bs-slide="prev" class="carrusel-prev"><img src="../../../../assets/images/btn-carousel-prev.svg" alt="anterior" /></button>
      <button *ngIf="data.length>1" type="button" data-bs-target="#carouselLeapmotor" data-bs-slide="next" class="carrusel-next"><img src="../../../../assets/images/btn-carousel-next.svg" alt="siguiente" /></button>
</div>